export const POST_IMPERSONATE="POST_IMPERSONATE"
export const POST_IMPERSONATE_SUCCESS="POST_IMPERSONATE_SUCCESS"
export const POST_IMPERSONATE_FAILED="POST_IMPERSONATE_FAILED"